import { ShopEntity } from 'src/firebase/db/Shops';

/**
 * 店舗住所を結合して取得
 */
export const getShopFullAddress = (val: ShopEntity) =>
  `${val['prefecture_name']}${val['city']}${val['address']}${val['address_number']}`;
